module.exports = __webpack_public_path__ + "img/30_53.e2df0f69.png";